var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        "store-modal": "",
        color: "primary",
        width: "600px",
        icon: _vm.generateMessagePath("icon"),
        title: _vm.generateMessagePath("title")
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "mx-5",
                  attrs: {
                    disabled: !_vm.valid,
                    small: "",
                    color: "success",
                    loading: _vm.isEditing
                      ? _vm.isLoadingUpdate
                      : _vm.isLoadingCreate
                  },
                  on: { click: _vm.handleValidateClick }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.generateMessagePath("validate")) +
                      "\n    "
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: {
            input: function($event) {
              return _vm.$emit("valid", _vm.valid)
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8" } },
                    [
                      _c("custom-properties-selector", {
                        attrs: {
                          disabled: !!_vm.currentActionPlan.node_id,
                          rules: [
                            v =>
                              !!v ||
                              _vm.generateMessage("actions.create.noproperty")
                          ]
                        },
                        on: { newItem: _vm.handlePropertyChange },
                        model: {
                          value: _vm.item.node_id,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "node_id", $$v)
                          },
                          expression: "item.node_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          label: _vm.generateMessage(
                            "actions.create.onsite_intervention"
                          ),
                          "hide-details": "",
                          dense: ""
                        },
                        model: {
                          value: _vm.item.on_site,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "on_site", $$v)
                          },
                          expression: "item.on_site"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _vm.isEditing
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("custom-date-item-selector", {
                            attrs: {
                              "input-date": "datetime",
                              "input-item": "type_id",
                              namespace: "actions/status"
                            },
                            model: {
                              value: _vm.item.action_status,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "action_status", $$v)
                              },
                              expression: "item.action_status"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.priorities,
                          "item-text": "name",
                          rules: [
                            v =>
                              !!v ||
                              _vm.generateMessage("actions.create.nopriority")
                          ],
                          "item-value": "id",
                          label:
                            _vm.generateMessage("actions.create.priorities") +
                            " *",
                          required: "",
                          dense: "",
                          outlined: ""
                        },
                        on: { input: _vm.updateDeadline },
                        model: {
                          value: _vm.item.priority_id,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "priority_id", $$v)
                          },
                          expression: "item.priority_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.types,
                          "item-text": "name",
                          dense: "",
                          "item-value": "id",
                          rules: [
                            v =>
                              !!v ||
                              _vm.generateMessage("actions.create.notype")
                          ],
                          label:
                            _vm.generateMessage("actions.create.type") + " *",
                          required: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.item.type_id,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "type_id", $$v)
                          },
                          expression: "item.type_id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.generateMessage(
                            "actions.create.start_date"
                          ),
                          type: "date",
                          rules: [
                            v =>
                              !!v ||
                              _vm.generateMessage("actions.create.nodt_date")
                          ],
                          dense: "",
                          outlined: ""
                        },
                        on: { input: _vm.updateDeadline },
                        model: {
                          value: _vm.item.start_datetime,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "start_datetime", $$v)
                          },
                          expression: "item.start_datetime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.generateMessage(
                            "actions.create.deadline_datetime"
                          ),
                          min: _vm.item.start_datetime,
                          dense: "",
                          outlined: "",
                          type: "date"
                        },
                        model: {
                          value: _vm.item.deadline_datetime,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "deadline_datetime", $$v)
                          },
                          expression: "item.deadline_datetime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("custom-text-area", {
                        attrs: {
                          required: "",
                          loading: _vm.loadingDesc,
                          "error-messages": _vm.messageDesc,
                          label:
                            _vm.generateMessage("actions.create.description") +
                            " *"
                        },
                        on: {
                          paste: _vm.addDocument,
                          input: _vm.clearMessageDesc
                        },
                        model: {
                          value: _vm.item.description,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "description", $$v)
                          },
                          expression: "item.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12" } },
                    [
                      _c("technician-selection-dialog", {
                        ref: "techSelector",
                        attrs: {
                          multiple: "",
                          "entity-id": _vm.currentActionPlan.entity_nav_full_id,
                          "property-id": _vm.propertyId,
                          placeholder: _vm.generateMessage(
                            "actions.create.authors"
                          ),
                          rules: [
                            v =>
                              !!v.length ||
                              _vm.generateMessage(
                                "actions.create.no_person_in_charge"
                              )
                          ]
                        },
                        model: {
                          value: _vm.item.staffs_in_charge_id,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "staffs_in_charge_id", $$v)
                          },
                          expression: "item.staffs_in_charge_id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("v-checkbox", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          label: _vm.generateMessage("actions.create.mail.send")
                        },
                        model: {
                          value: _vm.mailChecked,
                          callback: function($$v) {
                            _vm.mailChecked = $$v
                          },
                          expression: "mailChecked"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    [
                      _c("v-hover", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ hover }) {
                              return [
                                _c("v-checkbox", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    disabled: _vm.daybookState,
                                    label: _vm.daybookHover(hover)
                                  },
                                  model: {
                                    value: _vm.item.daybook,
                                    callback: function($$v) {
                                      _vm.$set(_vm.item, "daybook", $$v)
                                    },
                                    expression: "item.daybook"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.daybookState & _vm.isEditing
                        ? _c("v-checkbox", {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              label: _vm.generateMessage(
                                "actions.create.daybook_forced"
                              )
                            },
                            model: {
                              value: _vm.item.daybook_forced,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "daybook_forced", $$v)
                              },
                              expression: "item.daybook_forced"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }